export default "<xo-tile title=\"System Component\">\n</xo-tile>\n";